// ==============================
// 파일명 : src/constants/users/accountSync.js
// 역할 : Firebase Authentication과 Firestore 사용자 동기화에 필요한 Cloud Function 이름,
//         공통 메시지, 기본값, 배포 가이드를 통합 관리하여 계정 관련 로직이 일관된
//         문구를 재사용하고 운영자가 신속하게 문제를 파악할 수 있도록 돕는 상수 모음
// 수정일 : 2025-10-14
// ==============================

import { DEFAULT_USER_TEMP_PASSWORD } from "./defaults"; // [수정-2025-10-14] 공통 임시 비밀번호 상수 재사용

const ACCOUNT_SYNC_FUNCTIONS = {
  create: "adminCreateUser", // [수정-2025-10-14] Cloud Function - 사용자 생성 이름 상수
  update: "adminUpdateUser", // [수정-2025-10-14] Cloud Function - 사용자 정보 갱신 이름 상수
  remove: "adminDeleteUser", // [수정-2025-10-14] Cloud Function - 사용자 삭제 이름 상수
};

const ACCOUNT_SYNC_FUNCTION_NAMES_LABEL = Object.values(ACCOUNT_SYNC_FUNCTIONS).join(", "); // [수정-2025-10-14] 함수 이름 목록 라벨 상수

const ACCOUNT_SYNC_DEPLOYMENT_HINT =
  "Firebase CLI에서 `firebase deploy --only functions` 명령을 실행하거나 Firebase Emulator Suite가 실행 중인지 확인해주세요."; // [수정-2025-10-14] Cloud Function 배포 안내 문구 상수

export const USER_ACCOUNT_SYNC = {
  functions: ACCOUNT_SYNC_FUNCTIONS, // [수정-2025-10-14] 계정 동기화에 쓰이는 Cloud Function 이름 묶음
  labels: {
    functionNames: ACCOUNT_SYNC_FUNCTION_NAMES_LABEL, // [수정-2025-10-14] Cloud Function 목록 라벨
  },
  guides: {
    deploymentHint: ACCOUNT_SYNC_DEPLOYMENT_HINT, // [수정-2025-10-14] Cloud Function 배포 가이드 문구
  },
  messages: {
    createFailed: "사용자 생성 중 오류가 발생했습니다.", // [수정] 생성 실패 안내
    updateFailed: "사용자 정보 수정 중 오류가 발생했습니다.", // [수정] 수정 실패 안내
    deleteFailed: "사용자 삭제 중 오류가 발생했습니다.", // [수정] 삭제 실패 안내
    uidMissing: "Firebase UID를 확인할 수 없습니다.", // [수정] UID 누락 안내
    functionDeploymentMissing: `필요한 Firebase Cloud Functions가 배포되지 않았거나 현재 프로젝트에서 사용할 수 없습니다.`, // [수정-2025-10-14] Cloud Function 미배포 기본 안내
  },
  defaults: {
    passwordFallback: DEFAULT_USER_TEMP_PASSWORD, // [수정-2025-10-14] Firebase 정책에 맞춘 공통 임시 비밀번호 사용
  },
  errorMessages: {
    alreadyExists: "이미 사용 중인 이메일입니다.", // [수정-2025-10-14] 중복 이메일 경고 메시지
    unauthenticated: "관리자 인증이 필요합니다. 다시 로그인해주세요.", // [수정-2025-10-14] 인증 필요 안내
    permissionDenied: "권한이 없습니다. 관리자 계정으로 로그인해주세요.", // [수정-2025-10-14] 권한 부족 안내
    invalidArgument: "입력 정보가 올바르지 않습니다.", // [수정-2025-10-14] 유효성 오류 기본 안내
    notFound: "사용자를 찾을 수 없습니다.", // [수정-2025-10-14] 대상 미존재 안내
    functionUnavailable: "서버 기능이 아직 준비되지 않았습니다. 관리자에게 문의하세요.", // [수정-2025-10-14] 미배포 함수 호출 안내
    unavailable: "서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.", // [수정-2025-10-14] 네트워크 장애 안내
    deadlineExceeded: "요청 시간이 초과되었습니다. 다시 시도해주세요.", // [수정-2025-10-14] 타임아웃 안내
    internal: "서버 내부 오류가 발생했습니다. 관리자에게 문의하세요.", // [수정-2025-10-14] 서버 내부 오류 안내
  },
};

export const USER_ACCOUNT_SYNC_LOG_PREFIX = "[UserAccountSync]"; // [수정] 로그 접두사 상수